<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (logicalConfig && editForm) {
    <form [windeDisableFormControls]="viewInReadOnly ? editForm : null" name="editForm">
        <div class="form-group row justify-content-center mt-3">
            <div class="col-11 row align-items-center">
                <div class="col-12">
                    <h6>Management IP addresses</h6>
                </div>
                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_startIp"> Start IP address </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="startIpInput" id="link-config_startIp"></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_defaultGateway"> Default GW IP </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="defaultGatewayInput"
                                    id="link-config_defaultGateway"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_subnetMask">
                            Subnet mask width
                            <small class="form-text text-muted">0-32</small>
                        </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="subnetMaskInput"
                                    id="link-config_subnetMask"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_managementVid">
                            Management VLAN
                            <small class="form-text text-muted">1-4094</small>
                        </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="managementVidInput"
                                    id="link-config_managementVid"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto"> IP-less TU </span>
                        <div class="col-6">
                            <sui-toggle-component [config]="ipLessTuToggle"></sui-toggle-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>

        <div class="form-group row justify-content-center mt-3">
            <div class="col-11 row align-items-center">
                <div class="col-12">
                    <h6>SNMP managers</h6>
                </div>
                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_snmpVersion"> SNMP Version </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="snmpVersionInput"
                                    id="link-config_snmpVersion"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_snmpIP"> IP address </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="snmpIPInput" id="link-config_snmpIP"></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_trap"> Trap Community </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="trapInput" id="link-config_trap"></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_engineId"> Engine ID </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="engineIdInput"
                                    id="link-config_engineId"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_udpPort">
                            UDP-Port
                            <small class="form-text text-muted">0-64000</small>
                        </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="udpPortInput" id="link-config_udpPort"></winde-reactive-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>

        <div class="form-group row justify-content-center mt-3">
            <div class="col-11 row align-items-center">
                <div class="col-12">
                    <h6>Authentication</h6>
                </div>
                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_SSID"> MultiHaul/MultiHaul TG: SSID </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="ssidInput" id="link-config_SSID"></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_pasw"> Password </span>
                        <div class="col-6">
                            <winde-reactive-input [form]="editForm" [input]="ssidpwInput" id="link-config_pasw"></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_user_name"> User: Name </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="inputMngUname"
                                    id="link-config_user_name"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>

                <div class="col-6 mt-2">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_user_pswrd"> Password </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="inputMngUpass"
                                    id="link-config_user_pswrd"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>

        <div class="form-group row justify-content-center mt-3">
            <div class="col-11 row align-items-center">
                <div class="col-12">
                    <h6>Resiliency</h6>
                </div>
                <div class="col-6">
                    <div class="row align-items-center">
                        <span class="col-6 form-label my-auto" for="link-config_ccmInterval"> CCM Interval </span>
                        <div class="col-6">
                            <winde-reactive-input
                                    [form]="editForm"
                                    [input]="ccmIntervalInput"
                                    id="link-config_ccmInterval"
                            ></winde-reactive-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
}
